import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const Instagram = t0 => {
  const $ = _c(7);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M16 7.784a8.216 8.216 0 100 16.433 8.216 8.216 0 000-16.433zm0 13.55a5.334 5.334 0 110-10.668 5.334 5.334 0 010 10.667z" clipRule="evenodd" />;
    t2 = <path d="M26.461 7.459a1.92 1.92 0 11-3.84 0 1.92 1.92 0 013.84 0z" />;
    t3 = <path d="M16 0c-4.345 0-4.89.019-6.597.096-2.6.119-4.884.756-6.718 2.59C.852 4.518.215 6.802.096 9.402.019 11.109 0 11.655 0 16s.019 4.89.096 6.597c.119 2.6.756 4.884 2.59 6.718 1.833 1.833 4.117 2.47 6.717 2.589 1.706.077 2.252.096 6.597.096 4.345 0 4.89-.019 6.597-.096 2.6-.119 4.884-.756 6.718-2.59 1.833-1.833 2.47-4.117 2.589-6.717.077-1.706.096-2.252.096-6.597 0-4.345-.019-4.89-.096-6.597-.119-2.6-.756-4.884-2.59-6.718C27.482.852 25.198.215 22.598.096 20.891.019 20.345 0 16 0zm0 2.883c4.272 0 4.779.016 6.465.093 1.822.083 3.511.448 4.811 1.748 1.3 1.3 1.665 2.99 1.748 4.81.077 1.687.093 2.194.093 6.466s-.016 4.779-.093 6.465c-.083 1.822-.448 3.511-1.748 4.811-1.3 1.3-2.99 1.665-4.81 1.748-1.687.077-2.194.093-6.466.093s-4.779-.016-6.465-.093c-1.822-.083-3.511-.448-4.811-1.748-1.3-1.3-1.665-2.99-1.748-4.81-.077-1.687-.093-2.194-.093-6.466s.016-4.779.093-6.465c.083-1.822.448-3.511 1.748-4.811 1.3-1.3 2.99-1.665 4.81-1.748 1.687-.077 2.194-.093 6.466-.093z" clipRule="evenodd" />;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== props) {
    t4 = <IconWrapper {...props} viewBox="0 0 32 32" variant="solid">{t1}{t2}{t3}</IconWrapper>;
    $[5] = props;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
export { Instagram };